import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import { ThemeContext } from "styled-components";
import styled from "styled-components";
import { OutSideClick } from "../Utility/Method/OutSideClick";
import Col from './Column'
import StyledButton from "./Button";
import closeIcon from ".././Assets/icon/closeIcon.png"
const StyledModal = styled.div`
display : flex;
/* padding : 15px; */
width : auto;
height : auto;
background-color: transparent;
/* box-shadow : ${props => props.theme.shadow}; */
border-radius: ${props => props.theme.borderRadius};
`;
const StyledModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 500;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 250ms cubic-bezier(0, 0, 0.2, 1);
  opacity: 0;
  pointer-events: none;
  &.open {
    opacity: 1;
    pointer-events: all;
  }
`;
const Wrapper = styled(Col)`
  flex-direction: column;
  justify-content: flex-start;
  background-color: white !important;
  width: 800px !important;
  height: 600px;
  border-radius: 15px;
  padding: 8px; 
     @media screen and (max-width: 768px) {
       width : 100vw !important;
    min-height: -webkit-fill-available;
   height : 100vh;
   border-radius : 0px;
     }
`
const Header = styled(Col)`
height : 70px;
border-bottom : ${props => props.theme.border};
`
const HeaderTitle = styled(Col)`
height : 100%;
font-size : ${props => props.theme.fontSizeLg};
`
const HeaderAction = styled(Col)`
height : 100%;
img {
  width : 15px;
  height : 15px;
  cursor: pointer;
}
`
const Container = styled(Col)`
height : 440px;
flex-direction : column;
     @media screen and (max-width: 768px) {
       height : calc(100vh - 130px);
     }
`
const Footer = styled(Col)`
height : 90px;
border-top : ${props => props.theme.border};
button {
  width : 100%;
  height : 45px;
};
`
const Modal = props => {
  const theme = useContext(ThemeContext);
  const [show, setShow] = useState(props.visible);
  const { hasWrapper, headerTitle, onConfirm, onCancel, onClose, confirmText, loading, disable } = props
  const ModalRef = useRef();

  const callBack = () => {
    if (props.onCancel) {
      setShow(false);
      if (onCancel) {
        return onCancel()
      } else if (onClose) {
        return onClose()
      } else {
        return null;
      };
    }
  };
  const ClickFunc = e => {
    OutSideClick(e, ModalRef, callBack);
  };
  useEffect(() => {
    setShow(props.visible);
    {
      props.visible === true &&
        window.addEventListener("mousedown", ClickFunc, false);
    }
    return () => {
      props.visible === true &&
        window.removeEventListener("mousedown", ClickFunc, false);
    };
  }, [props.visible]);
  useMemo(() => {
    if (props.visible === true) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = "auto"
    }
  },
    [props.visible]
  )
  return (
    <StyledModalContainer
      className={show ? "open" : "close"}
      show={show}
      {...props}
    >
      <StyledModal theme={theme} ref={ModalRef} show={show} {...props}>
        {!hasWrapper && props.children}
        {
          hasWrapper &&
          <Wrapper>
            <Header
              xl={23} lg={23} md={23} sm={23} xs={23}
            >
              <HeaderAction
                xl={3} lg={3} md={3} sm={6} xs={6}
                onClick={props.headerActionHandler}
              >
                {props.headerActionText || props.headerActionComponent}
              </HeaderAction>
              <HeaderTitle
                xl={18} lg={18} md={18} sm={12} xs={12}
              >
                {headerTitle}
              </HeaderTitle>
              <HeaderAction
                xl={3} lg={3} md={3} sm={6} xs={6}
              >
                <img
                  onClick={props.onCancel || props.onClose}
                  src={closeIcon} />
              </HeaderAction>
            </Header>

            <Container
              xl={23} lg={23} md={23} sm={23} xs={23}
            >
              {
                props.children
              }
            </Container>

            <Footer
              xl={23} lg={23} md={23} sm={23} xs={23}
            >
              <StyledButton
                primary
                loading={loading}
                onClick={onConfirm}
                disable={disable === true ? true : false}
              >
                {confirmText}
              </StyledButton>
            </Footer>
          </Wrapper>
        }
      </StyledModal>
    </StyledModalContainer>
  );
};
export default Modal;
